<script setup lang="ts">

import {computed} from "vue";
import {Address} from "@/shared/graphql/types";
import {faCircleCheck} from "@fortawesome/pro-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

interface Props {
  address: Address
  showDefault?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  showDefault: true
})

const name = computed(() => [props.address.firstname, props.address.lastname].join(" "))

</script>

<template>
  <div class="flex flex-col space-y-0">
    <span v-if="address.company">{{ address.company }}</span>
    <span v-if="name">{{ name }}</span>
    <div>
      <span v-if="address.street" class="capitalize-first">{{ address.street }}</span>
      <span v-if="address.houseNumber" class="ml-2">{{ address.houseNumber }}</span>
      <span v-if="address.busNumber" class="ml-1">/ {{ address.busNumber }}</span>
      <FontAwesomeIcon v-if="address.default && showDefault" :icon="faCircleCheck" class="ml-2 text-green-500 inline"/>
    </div>
    <div v-if="address.extra">
      <span>{{ address.extra }}</span>
    </div>
    <div>
      <span v-if="address.zipCode">{{ address.zipCode }}</span>
      <span v-if="address.city" class="ml-1">{{ address.city }}</span>
    </div>
    <span v-if="address.country">{{ address.country.label }}</span>
  </div>
</template>

<style scoped>
.capitalize-first {
  text-transform: capitalize;
}
</style>